/** @var { LoanCalculatorState } */
const STATE = {
  data: [],
  addEditModal: {
    show: false,
    loading: false,
    data: {},
  },
};

export default STATE;
